// src/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

export default function Footer() {
  return (
    <footer className=" border-t border-gray-400 bg-gray-800 text-gray-400 py-6">
      <div className="flex flex-col md:flex-row items-center justify-between px-6 md:px-12">
        {/* links */}
        <div className="flex space-x-6 mb-4 md:mb-0">
          <Link to="/about" className="hover:text-white transition">
            About
          </Link>
          <Link to="/terms" className="hover:text-white transition">
            Terms of Service
          </Link>
          <Link to="/privacy" className="hover:text-white transition">
            Privacy Policy
          </Link>
        </div>

        {/* social icons */}
        <div className="flex space-x-4">
          <a
            href="https://instagram.com/koi_create"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition"
          >
            <FaInstagram size={20} />
          </a>
          <a
            href="https://tiktok.com/@koi__create"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition"
          >
            <SiTiktok size={20} />
          </a>
          <a
            href="https://www.facebook.com/people/KoiCreate/61572575333985/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition"
          >
            <FaFacebookF size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
}
